import { Children } from "react";
import { Field, FormikProps } from "formik";
import styles from "../../lessonsForm.module.css";
import { useGrades } from "../../../../../hooks/useGrades";
import { GetGrade_getGrades } from "../../../../../__generated__/gql-types/GetGrade";
import { formatGrade } from "../../../../../utils/formatGrade";

const GRADE_TTITLE = "Grado";
const GRADE_PLACEHOLDER = "Sin grado asignado";
interface IGradeInputProps {
  errors: FormikProps<any>["errors"];
  touched: FormikProps<any>["touched"];
  values: FormikProps<any>["values"];
}

export function GradeInput({ errors, touched, values }: IGradeInputProps) {
  const { grades } = useGrades();
  const sortGrades = [...grades].sort(
    (a, b) => Number(a.grade) - Number(b.grade)
  );

  const fieldClassName =
    errors.grade_id && touched.grade_id
      ? styles.formFieldsError
      : styles.formFieldSelect;

  return (
    <>
      <label htmlFor="grade_id">{GRADE_TTITLE}</label>
      <Field
        as="select"
        id="grade_id"
        name="grade_id"
        value={values.grade_id}
        className={fieldClassName}
      >
        <option value="">
          {GRADE_PLACEHOLDER}
        </option>
        {Children?.toArray(
          sortGrades?.map((grade) => (
            <option value={grade?.id}>{formatGrade(grade)}</option>
          ))
        )}
      </Field>
    </>
  );
}
